module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAb1BMVEUAAAAhof8gof8goP8hoP8iof85y/8iov8hof8iof80tP8goP8hof8gof8gof8hof8gov8hof8hof8goP8goP8gof8gov8iov8ho/8gof8kov8ipv8jov8mpv8gof8hof8hoP8hoP8gof8iqv8gof9Gxi2iAAAAJHRSTlMA+u/92iYEQoczCOTBlYB2b0zy382naWFUPioeFhT007qyrQ8aeahmAAAAqElEQVQoz83QuQ6DMBRE0TFOMDb7Hghknf//xhSWKCxs0kTKaW/x9AZ1Kr3SGikDWlBe4bEIAQp4RT/KazAXHN28JqWBNVBOTjYd2dknL5IDnPykFIwUACVYwMk5I708KEvohjmcXFEoIE7IVvAFJ9eSoz3bkJlx8nxjAmvu8zecXLEPrWZUfDDqP2aqs8ckBU4MuENnJ69M4xvxDmwS7ii2XEY7Khz7AH7yF4+NXst4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/dataService2.png
// module id = BBlL
// module chunks = 104